/* ============
 * Customer Transformer
 * ============
 *
 * The transformer for the customer.
 */

import Transformer from './Transformer'

export default class CustomerTransformer extends Transformer {
  /**
   * Method used to transform a fetched customer.
   *
   * @param customer The fetched customer.
   *
   * @returns {Object} The transformed customer.
   */
  static fetch (customer) {
    return {
      id: customer['auth0_id'],
      cust_uid: customer['cust_uid'],
      email: customer['email'],
      source: customer['auth0'].identities[0].provider === 'auth0' ? 'TuangoPremio' : customer['auth0'].identities[0].provider,
      firstName: customer['auth0']['user_metadata']['firstname'],
      lastName: customer['auth0']['user_metadata']['lastname'],
      avatar: customer['auth0'].picture,
      role: customer['https://tuango.ca/user_metadata'] ? customer['https://tuango.ca/user_metadata']['role'] : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/CustomerTransformer.js